import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useRequest } from "../../../hooks/useRequest";
// import useRazorpay from "react-razorpay";
import { useAppContext } from "../../../context/useAppContext";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Progress from "../../common/Progress";
import { priceSymbol } from "../../../utils/symbol";
import { host } from "../../../utils/baseUrl";
import { checkCODEnabled } from "../../../utils/helper";

const PaymentStyle = styled.div`
  .tittle {
    font-size: 27px;
    font-weight: 600;
    line-height: 35px;
    text-align: left;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .payment__methods__list {
    .payment__method__wrapper {
      position: relative;
      margin: 22px 0;
      .pay__now {
        font-size: 15px;
        font-weight: 700;
        line-height: 23px;
        text-align: center;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        background-color: #ae0000;
        color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 26px;
        width: 180px;
        &:disabled {
          background: #a7a7a7;
        }
      }
    }
    .payment__method {
      border: 0.75px solid #d9d9d9;
      height: 75px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 18px 18px 18px 50px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      line-height: 35px;
      text-align: left;
      img {
        width: auto;
      }
    }
    input {
      accent-color: #ae0000;
      position: absolute;
      top: 50%;
      transform: translateY(-59%);
      left: 18px;
      width: 20px;
      height: 20px;
      &:checked {
        + label {
          border: 0.75px solid #ae0000;
          background-color: #ffecec;
        }
      }
    }
  }
  .coupon__and__subtotal {
    margin-top: 52px;
    display: flex;
    justify-content: flex-end;
    .coupon__wrapper {
      position: relative;
      flex: 0 0 450px;
      input {
        width: 100%;
        height: 70px;
        border: 0.75px solid #303030;
        border-radius: 7.5px;
        padding: 20px;
        font-family: "Poppins";
      }
      .apply__code {
        font-size: 15px;
        font-weight: 600;
        line-height: 23px;
        background: none;
        text-decoration: underline;
        text-underline-offset: 1px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 24px;
        cursor: pointer;
      }
    }
    .payment__summary {
      flex: 0 0 450px;
      border-radius: 7.5px;
      border: 0.75px solid #d9d9d9;
      background: #fcfcfc;
      padding: 14px 20px;
    }
    .subtotal__amount {
      display: flex;
      padding: 6px 0;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;
      }
      .amount {
        font-size: 18px;
        font-weight: 600;
        line-height: 23px;
        color: #ae0000;
        span {
          font-size: 11px;
          font-weight: 400;
          line-height: 15px;
          color: #303030;
          display: inline-block;
          margin-left: 15px;
        }
      }
    }
  }
`;

const PaymentDraft = ({ createOrderData, orderSummaryData, draftId }) => {
  const [handleRequest] = useRequest();
  // const [Razorpay] = useRazorpay();
  const {
    user,
    checkoutCartData,
    appliedCoupon,
    setCheckoutCartData,
    setThankyouData,
    coupon
  } = useAppContext();
  const [selectedMethod, setSelectedMethod] = useState();

  // const {draftId} = useParams()

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [fetchTransactions, { isLoading: fetchLoading, state: transactionData }] =
    useRequest();

  const handleDeleteCart = async (cartId) => {
    const path = `/instacart/${cartId}/delete`;
    await handleRequest({ path, method: "DELETE" });
  };

  const handleCreateOrder = async (paymentId, orderData) => {
    setIsLoading(true);
    const uid = localStorage.getItem('uid');

    const path = `/order-draft/checkout/${draftId}/store`;
    const response = await handleRequest({
      path,
      method: "POST",
      body: JSON.stringify({
        ...transactionData.data,
        shippingStatus: "confirmed",
        products: transactionData.data.items.map((element) => ({
          productId: element.product._id,
          variation: element.variation,
          qty: element.quantity,
          scheduleDate: element.schedule,
        })),
        paymentRefNumber: paymentId,
        paymentMethod: selectedMethod,
        ...(uid && { uid }),
      }),
    });
    if (!response.success) {
      setIsLoading(false);
      return toast.error(response.message);
    }
    handleDeleteCart(checkoutCartData?._id);
    setThankyouData({
      products: orderSummaryData?.items,
      subtotal: { subtotal: orderSummaryData?.subtotal, gst: orderSummaryData?.tax?.gst, pst: orderSummaryData?.tax?.pst, totalAmount: orderSummaryData?.total, shippingCharges: orderSummaryData?.shippingCharge, couponDiscount: orderSummaryData?.couponDiscount },
      address: orderSummaryData?.billingAddress,
      paymentMethod: selectedMethod,
      orderId: response?.data?.orderId,
      orderDate: new Date().toLocaleDateString(),
    });
    setCheckoutCartData();
    navigate("/thankyou", { state: { fromCheckout: true } });
  };

  const handlePayment = async () => {
    try {
      setIsLoading(true);
      const uid = localStorage.getItem('uid');

      const path = `/order/checkout/stripe`;
      const response = await handleRequest({
        path,
        method: "POST",
        body: JSON.stringify({
          ...transactionData.data,
          products: transactionData.data.items.map((element) => ({
            productId: element.product._id,
            variation: element.variation,
            qty: element.quantity,
            scheduleDate: element.schedule,
          })),
          draftId: draftId,
          success_url: `${host}/thankyou2`,
          cancel_url: `${host}/payment-failed`,
          paymentMethod: "stripe",
          ...(uid && { uid }),
        }),
      });

      console.log(response)
      window.location.href = response.data.url;
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message || "Payment processing failed. Please try again.");
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTransactions({ path: `/order-draft/${draftId}/show-ungroup` });
  }, [])

  return (
    <>
      <PaymentStyle>
        <h2 className="tittle">Payments</h2>
        <div className="payment__methods__list">
          <div className="payment__method__wrapper">
            <input
              id="method1"
              type="radio"
              name="payment_method"
              value={"stripe"}
              onChange={(e) => setSelectedMethod(e.target.value)}
              checked={selectedMethod === "stripe"}
            />
            <label htmlFor="method1" className="payment__method">
              <img src="/images/stripe.png" alt="stripe" />
            </label>
            <button className="pay__now" onClick={() => handlePayment()} disabled={selectedMethod !== "stripe" || isLoading}>
              {isLoading ? "Processing..." : "Pay Now"}
            </button>
          </div>
          {checkCODEnabled(transactionData?.data?.items) && (
            <div className="payment__method__wrapper">
              <input
                id="method2"
                type="radio"
                name="payment_method"
                value={"cod"}
                onChange={(e) => setSelectedMethod(e.target.value)}
                checked={selectedMethod === "cod"}
              />
              <label htmlFor="method2" className="payment__method">
                Cash on delivery
              </label>
              <button
                className="pay__now"
                onClick={() => handleCreateOrder("", createOrderData)}
                disabled={selectedMethod !== "cod"}
              >
                Order Now
              </button>
            </div>
          )}
        </div>
        <div className="coupon__and__subtotal">
          {/* <div className="coupon__wrapper">
            <div style={{ position: "relative" }}>
              <input
                type="text"
                placeholder="Enter coupon code (ex: FIRSTPAY)"
                value={createOrderData?.coupon}
              />
              <h2 className="apply__code" onClick={}>Apply Code</h2>
            </div>
          </div> */}
          <div className="payment__summary">
            <div className="subtotal__amount">
              <h3 className="title">SUB TOTAL</h3>
              <h2 className="amount">
                {priceSymbol}
                {orderSummaryData?.subtotal?.toFixed(2)}
              </h2>
            </div>
            <div className="subtotal__amount">
              <h3 className="title">
                DISCOUNT
                {appliedCoupon && <span style={{ fontSize: "10px", color: "#4caf50" }}>( {appliedCoupon} )</span>}
              </h3>
              <h2 className="amount" style={{ color: "rgb(76, 175, 80)" }}>
                {priceSymbol}
                {orderSummaryData?.couponDiscount?.toFixed(2)}
              </h2>
            </div>
            {orderSummaryData?.usedReward > 0 && (
              <div className="subtotal__amount">
                <h3 className="title">IB Rewards</h3>
                <h2 className="amount" style={{ color: "rgb(76, 175, 80)" }}>
                  {priceSymbol}
                  {orderSummaryData?.usedReward?.toFixed(2)}
                </h2>
              </div>
            )}
            <div className="subtotal__amount">
              <h3 className="title">SHIPPING</h3>
              <h2 className="amount">
                {priceSymbol}
                {orderSummaryData?.shippingCharge?.toFixed(2)}
              </h2>
            </div>
            {/* <i style={{ fontSize: "12px", color: "#211f1f", fontWeight: 500 }}>
              ( Shipping Fee will be confirmed after Order Confirmation )
            </i> */}
            <div className="subtotal__amount">
              <h3 className="title">GST</h3>
              <h2 className="amount">
                {priceSymbol}
                {/* {orderSummaryData?.taxAmount} */}
                {orderSummaryData?.tax?.gst?.toFixed(2)}
              </h2>
            </div>
            <div className="subtotal__amount">
              <h3 className="title">PST</h3>
              <h2 className="amount">
                {priceSymbol}
                {orderSummaryData?.tax?.pst?.toFixed(2)}
              </h2>
            </div>
            <div className="subtotal__amount">
              <h3 className="title">TOTAL</h3>
              <h2 className="amount">
                {priceSymbol}
                {orderSummaryData?.total?.toFixed(2)}
              </h2>
            </div>
            <span style={{ fontSize: "12px", color: "#211f1f", fontWeight: 500, display: "block" }}>( incl. taxes & excluding shipping )</span>
          </div>
        </div>
      </PaymentStyle>
      {isLoading && <Progress />}
    </>
  );
};

export default PaymentDraft;
